module.exports = __webpack_public_path__ + "img/img_payment.7074e66d.png";